import { render, staticRenderFns } from "./JsDosGameCard.vue?vue&type=template&id=0aa76730&"
import script from "./JsDosGameCard.vue?vue&type=script&lang=js&"
export * from "./JsDosGameCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports